'use strict';

jQuery(document).ready(function ($) {
  var utmCookieKey = '__bm_utm_campaign_url=';
  var queryString = window.location.search;

  if (queryString) {
    var qsParams = new URLSearchParams(queryString);

    // console.log(qsParams);
    if (qsParams.get('utm_campaign')) {
      document.cookie = utmCookieKey + encodeURIComponent(window.location.href) + ';path=/;';
      // console.log(utmCookieKey + encodeURIComponent(window.location.href));
      updateGfUtm();
    }
  } else {
    updateGfUtm();
  }

  function updateGfUtm() {
    var gravityForms = document.querySelectorAll('.gform_wrapper');

    if (gravityForms) {
      if (document.cookie.split(';').some(function (item) {
        return item.trim().indexOf(utmCookieKey) == 0;
      })) {
        var cookieValue = document.cookie.split('; ')
        // .find(row => row.startsWith(utmCookieKey))
        .find(function (row) {
          return row.startsWith(utmCookieKey);
        }).split('=')[1];

        // console.log(cookieValue);

        if (cookieValue) {
          var url = new URL(decodeURIComponent(cookieValue));
          var searchQuery = url.search;

          if (searchQuery) {
            var urlParams = new URLSearchParams(searchQuery);
            var campaign = urlParams.get('utm_campaign');
            var content = urlParams.get('utm_content');

            gravityForms.forEach(function (gform, index) {
              var form = gform.querySelector('form');
              var utmCampaignField = form.querySelector('.utm_campaign input');
              var utmContentField = form.querySelector('.utm_content input');

              if (typeof utmCampaignField !== 'undefined') {
                utmCampaignField.value = campaign;
              }

              if (typeof utmContentField !== 'undefined') {
                utmContentField.value = content;
              }
            });
          }
        }
      }
    }
  }
});


// WEBPACK FOOTER //
// ./scripts/routes/utm.js